module.exports = {"id":"49756","name":"Jakob Poulsen","rating":"73","photo":"./data/images/photos/2/49756.png","club":{"name":"FC Midtjylland","logo":"./data/images/clubs/FCMidtjylland.png"},"positions":["MC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JakobPoulsen0.json
// module id = 1885
// module chunks = 0